/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 41);
/******/ })
/************************************************************************/
/******/ ({

/***/ 41:
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

window.degToRad = function degToRad(degrees) {
    return degrees * Math.PI / 180;
};

window.radToDeg = function radToDeg(radians) {
    return radians * 180 / Math.PI;
};

window.UTIL = {
    sortArrayByKey: function sortArrayByKey() {
        var sorters = {
            string: function string(a, b) {
                if (a < b) {
                    return -1;
                } else if (a > b) {
                    return 1;
                }

                return 0;
            },
            number: function number(a, b) {
                return a - b;
            }
        };

        return function sortIt(ary, prop) {
            var type = _typeof(ary[0][prop]) || 'string';

            return ary.sort(function (a, b) {
                return sorters[type](a[prop], b[prop]);
            });
        };
    },
    isNotNumeric: function isNotNumeric(n) {
        return !(!isNaN(parseFloat(n)) && isFinite(n));
    },
    uniq: function uniq(array) {
        var result = Array.from(new Set(array));

        return result;
    },
    lastItem: function lastItem(array) {
        var length = array === null ? 0 : array.length;

        return length ? array[length - 1] : undefined;
    },
    keys: function keys(obj) {
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
            return [];
        }

        var keys = [];

        for (var k in obj) {
            keys.push(k);
        }

        return keys;
    },
    contains: function contains(a, obj) {
        if (!a || !obj) {
            return false;
        }

        var i = 0;

        while (i < a.length) {
            if (a[i] === obj) {
                return true;
            }

            i += 1;
        }

        return false;
    },
    clone: function clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    getQueryParam: function getQueryParam(variable, query) {
        if (!query) {
            query = window.location.search.substring(1);
        }

        var variables = [];

        if (typeof variable === 'string') {
            variables = [variable.toLowerCase()];
        } else {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(variable)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var v = _step.value;

                    variables.push(v.toLowerCase());
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        var vars = query.split('&');
        var i = 0;

        while (i < vars.length) {
            var pair = vars[i].split('=');

            if (Array.from(variables).includes(pair[0].toLowerCase())) {
                return this.parseValues(pair[1]);
            }

            i += 1;
        }

        return null;
    },
    getQueryAsObj: function getQueryAsObj(query) {
        if (!query) {
            query = window.location.search.substring(1);
        }

        var tmp = {};
        var vars = query.split('&');
        var i = 0;

        while (i < vars.length) {
            var pair = vars[i].split('=');

            tmp[pair[0]] = pair[1];
            i += 1;
        }

        return tmp;
    },
    parseValues: function parseValues(v) {
        if (typeof v !== 'string') {
            return v;
        }
        if (v === '') {
            return null;
        }
        if (v === 'true') {
            return true;
        }
        if (v === 'false') {
            return false;
        }
        if (!isNaN(Number(v))) {
            return Number(v);
        }
        if (v === 'null') {
            return null;
        }

        return v;
    },
    hexToString: function hexToString(int) {
        var k = (int + Math.pow(16, 6)).toString(16).substr(-6);

        return '#' + k.toString(16);
    }
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// a-util.js